export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10462.15fa48c1.jpg";